import * as React from "react"
import { Fragment } from "react"
import { StaticImage } from "gatsby-plugin-image"
import LinkButton from "./linkbutton"

const Hero = ({ location, title }) => {
    return (
        <Fragment>
            <section className="bmo-hero hero-hanging-card-right root-path">
                <div className="bmo-container">
                    <div className="hero-banner-image root-path">
                        {/* bg image */}
                    </div>
                    <div className="hero-banner-container">
                        <h1>{title}.</h1>
                        <h2>Start with us.</h2>
                        <LinkButton text="View our work" link="#main-content" buttonclass="hero-button link-button" iconclass="" target="_self" />
                    </div>
                    <div className="scroll-indicator">
                        <a href="#main-content">
                        <StaticImage
                            src="../images/caret-down.svg"
                            alt="caret-pointing-downwards"
                            objectFit="contain"
                            placeholder="blurred"
                            height={42}
                            width={42}
                            className="scrolldown-p1"
                        />
                        <span className="sr-only">Click here to scroll down to the first section</span>
                        </a>
                    </div>
                </div>
            </section>
        </Fragment>
    )
}

export default Hero